export default __webpack_public_path__ + "static/media/ico_shippment_step.1e1038f3.svg";